import React, { useEffect, useState } from 'react';

// Keep this coordinate system aligned with the pupil store's DrawBoomer.
const CANVAS_WIDTH = 753;
const CANVAS_HEIGHT = 765;
const BODY_HEIGHT = 510;
const ITEMS_BASE = 570;
const ITEMS_TOP = -195;

const useImageSize = (src) => {
    const [size, setSize] = useState(null);

    useEffect(() => {
        setSize(null);
        if (!src) return undefined;

        const image = new Image();
        image.onload = () => setSize({
            src,
            width: image.naturalWidth,
            height: image.naturalHeight,
        });
        image.src = src;

        return () => { image.onload = null; };
    }, [src]);

    return size && size.src === src ? size : null;
};

const BoomerItemPreview = ({ bodySrc, itemSrc, coordinates, itemName, className }) => {
    const body = useImageSize(bodySrc);
    const item = useImageSize(itemSrc);
    const yPad = ((BODY_HEIGHT - ITEMS_BASE) - ITEMS_TOP) / 2;
    const bodyY = body ? (CANVAS_HEIGHT - body.height) / 2 + yPad : 0;

    return (
        <svg
            className={className}
            viewBox={`0 0 ${CANVAS_WIDTH} ${CANVAS_HEIGHT}`}
            role='img'
            aria-label={itemSrc ? `${itemName} on Boomer` : 'Boomer preview'}
        >
            {body && (
                <image
                    href={bodySrc}
                    x={(CANVAS_WIDTH - body.width) / 2}
                    y={bodyY}
                    width={body.width}
                    height={body.height}
                />
            )}
            {body && item && (
                <image
                    href={itemSrc}
                    x={(CANVAS_WIDTH - item.width) / 2 + coordinates.x}
                    y={bodyY + coordinates.y}
                    width={item.width}
                    height={item.height}
                />
            )}
        </svg>
    );
};

export default BoomerItemPreview;
